module.exports = __webpack_public_path__ + "img/img_aboutus_1.1a89a5d6.jpg";